var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"text"},[_vm._v("Finding locations for your move")]),_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loading"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }